/*
 * @Author: Gavin Chan
 * @Date: 2021-07-01 16:53:52
 * @LastEditors: Gavin Chan
 * @LastEditTime: 2025-05-28 14:58:38
 * @FilePath: \frontend-erp-registration\src\store\modules\exam.ts
 * @Descriptions: todo
 */
import type { Module } from "vuex";
import type { IRootStore } from "@/store/interface";
export interface IExamStore {
  list: any[];
}

export const ExamModule: Module<IExamStore, IRootStore> = {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    LIST_PUSH(state) {
      state.list.push("1");
    }
  },
  actions: {}
};
